@for (breadcrumb of breadcrumbs; track breadcrumb.route) {
    <span
        class="wk-sb__item"
        [class.wk-sb__item--active]="breadcrumb.isActive"
        [class.wk-sb__item--clickable]="!breadcrumb.isActive"
        (click)="onBreadcrumbClick(breadcrumb)"
    >
        {{ breadcrumb.translateKey | translate }}
    </span>
    @if (!$last) {
        <i class="wk-sb__separator fa-solid fa-angle-right"></i>
    }
}
